import { RouteResponse } from "@gtpl/shared-models/hrms";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { Body, Controller, Post, Req } from "@nestjs/common";
import { ApiTags } from "@nestjs/swagger";
import { RouteDto } from "./dto/route.dto";
import { RouteRequest } from "./dto/route.request";
import { RouteService } from "./route.service";

@ApiTags('Route')
@Controller('route')
export class RouteController{
    constructor(
        private routeService : RouteService,
        private readonly applicationExceptionhandler: ApplicationExceptionHandler,

    ){}

    @Post('/createRoute')
    async createRoute(@Body() routeDto:RouteDto,isUpdate:boolean=false,@Req() request:Request): Promise<RouteResponse> {
        try {
            // console.log(departmentsDTO);
            return await this.routeService.createRoute(routeDto, false,request);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(RouteResponse, error)
        }
    }

    @Post('/updateRoute')
    async updateRoute(@Body() routeDto: RouteDto,@Req() request:Request): Promise<RouteResponse> {
        try {
        return await this.routeService.createRoute(routeDto, true,request);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(RouteResponse, error)
        }
    }

    @Post('/getAllRoute')
    async getAllRoute(@Req() request: Request): Promise<RouteResponse> {
        try {
        return await this.routeService.getAllRoute();
        } catch (error) {
            return this.applicationExceptionhandler.returnException(RouteResponse, error)
        }
    }

    @Post('/getAllActiveRoute')
  async getAllActiveRoute(@Req() request: Request): Promise<RouteResponse> {
      try {
          return await this.routeService.getAllActiveRoute();
      } catch (error) {
          return this.applicationExceptionhandler.returnException(RouteResponse, error)
      }
  }

  @Post('/activateOrDeactivateRoute')
  async activateOrDeactivateRoute(@Body() routeReq: RouteRequest): Promise<RouteResponse> {
      try {
          return await this.routeService.activateOrDeactivateRoute(routeReq);
      } catch (err) {
          return this.applicationExceptionhandler.returnException(RouteResponse, err);
      }
  }
}